import EssayType from "./QuestionType/EssayType";
import MultipleType from "./QuestionType/MultipleType";
import SingleType from "./QuestionType/SingleType";
import StartCamera from "./StartCamera";
import VideoType from "./QuestionType/VideoType";
import CodeEditor from "./ProgrammingQuestion/CodeEditor";
import FullPageLoader from "../../../components/Loader/FullPageLoader";
import { Bullets } from "ui-components";
import { forwardRef } from "react";
import { isSafari } from "../../../utils/Common/Constant";
import StartSafariCamera from "./StartSafariCamera";
interface AnswerQuestion {
  setSingleTypeValue: any;
  singleTypeValue: any;
  setMultipleTypeValue: any;
  multipleTypeValue: any;
  setEssayTypeValue: any;
  essayTypeValue: any;
  questionData: any;
  subTimer: number;
  SpeechRecognition: any;
  browserSupportsSpeechRecognition: any;
  transcript: string;
  currentQuestionIndex: number;
  transcriptEnabled: boolean;
  codingAnsTemplate: string;
  setCodingAnsTemplate: any;
  codeOutPut: any;
  testCases: any;
  setTestCases: any;
  setCodeOutput: any;
  handleSubmitAnswer: any;
  setStartQuestionLoader: any;
  startQuestionLoader: boolean;
  isBlinking: boolean;
  SetIsCodingQuestionEdited: any;
  isStartRecording: boolean;
  skillNameRef: any;
  questionTextRef: any;
  activeTimerRef: any;
  micImgRef: any;
  cameraStopped: boolean;
  essayCharCount: any;
  setEssayCharCount: any;
  setCodingSummary: any;
  setDisableNext: any;
  selectedLanguage: string;
  setSelectedLanguage: any;
}

const AnswerQuestion: React.ForwardRefRenderFunction<any, AnswerQuestion> = (
  {
    setSingleTypeValue,
    singleTypeValue,
    setMultipleTypeValue,
    multipleTypeValue,
    setEssayTypeValue,
    essayTypeValue,
    questionData,
    subTimer,
    SpeechRecognition,
    browserSupportsSpeechRecognition,
    transcript,
    currentQuestionIndex,
    transcriptEnabled,
    codingAnsTemplate,
    setCodingAnsTemplate,
    codeOutPut,
    testCases,
    setTestCases,
    setCodeOutput,
    handleSubmitAnswer,
    setStartQuestionLoader,
    startQuestionLoader,
    SetIsCodingQuestionEdited,
    isStartRecording,
    skillNameRef,
    questionTextRef,
    micImgRef,
    cameraStopped,
    essayCharCount,
    setEssayCharCount,
    setCodingSummary,
    setDisableNext,
    selectedLanguage,
    setSelectedLanguage,
  },
  ref,
) => {
  const renderQuestionType = (
    questionData: any,
    transcript: string,
    browserSupportsSpeechRecognition: any,
  ) => {
    switch (questionData?.types ?? questionData?.type) {
      case "Essay":
        return (
          <EssayType
            startQuestionLoader={startQuestionLoader}
            setEssayTypeValue={setEssayTypeValue}
            essayTypeValue={essayTypeValue}
            essayCharCount={essayCharCount}
            setEssayCharCount={setEssayCharCount}
          />
        );
      case "Single":
        return (
          <SingleType
            data={questionData}
            setSingleTypeValue={setSingleTypeValue}
            singleTypeValue={singleTypeValue}
            startQuestionLoader={startQuestionLoader}
          />
        );
      case "Multiple":
        return (
          <MultipleType
            data={questionData}
            setMultipleTypeValue={setMultipleTypeValue}
            multipleTypeValue={multipleTypeValue}
            startQuestionLoader={startQuestionLoader}
          />
        );
      case "Video":
        return (
          <VideoType
            browserSupportsSpeechRecognition={browserSupportsSpeechRecognition}
            transcript={transcript}
            transcriptEnabled={transcriptEnabled}
            micImgRef={micImgRef}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="row mt-4">
      {(questionData?.types ?? questionData?.type === "Coding") ? (
        <div className="col-lg-12 col-md-12 col-sm-12 posRelate">
          <div className="codingQuestion" ref={questionTextRef}>
            <div className="codingQuestionDisplay">
              <p>Q.{currentQuestionIndex ?? 1}</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: `${questionData?.question?.question || questionData?.question || ""}`,
                }}
              />
            </div>
            {questionData?.attachment && (
              <div className="ImageAttParent mb-2">
                <img
                  className="attachedImageQuestion"
                  src={questionData?.attachment}
                  alt="Attachment"
                />
              </div>
            )}
          </div>
          <CodeEditor
            ref={ref}
            questionData={questionData}
            codingAnsTemplate={codingAnsTemplate}
            setCodingAnsTemplate={setCodingAnsTemplate}
            setTestCases={setTestCases}
            setCodeOutput={setCodeOutput}
            codeOutPut={codeOutPut}
            testCases={testCases}
            timer={subTimer}
            currentQuestionIndex={currentQuestionIndex}
            questionId={questionData?.assessmentApplicantQuestionId}
            handleSubmitAnswer={handleSubmitAnswer}
            setStartQuestionLoader={setStartQuestionLoader}
            startQuestionLoader={startQuestionLoader}
            SetIsCodingQuestionEdited={SetIsCodingQuestionEdited}
            isStartRecording={isStartRecording}
            cameraStopped={cameraStopped}
            setCodingSummary={setCodingSummary}
            setDisableNext={setDisableNext}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
          />
        </div>
      ) : (
        <>
          <div className="col-lg-7 col-md-6 col-sm-12">
            <div className="questionSet">
              <div className="questionDisplay">
                <div className="question">
                  <div className="questionlist">
                    <div className="d-flex mb-1" ref={skillNameRef}>
                      {questionData?.skillName && (
                        <Bullets skillName={questionData?.skillName} />
                      )}
                    </div>
                    <div className="questionDisplay" ref={questionTextRef}>
                      <p>
                        Q.{currentQuestionIndex > 0 ? currentQuestionIndex : ""}
                      </p>
                      <p
                        className="currentQuestionIndex"
                        dangerouslySetInnerHTML={{
                          __html: `${questionData?.question?.question || questionData?.question || "-"}`,
                        }}
                      />
                    </div>
                    {questionData?.attachment && (
                      <div className="ImageAttParent mb-2">
                        <img
                          className="attachedImageQuestion"
                          src={questionData?.attachment}
                          alt="Attachment"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {renderQuestionType(
                questionData,
                transcript,
                browserSupportsSpeechRecognition,
              )}
            </div>
          </div>
          <div className="col-lg-5 col-md-6 col-sm-12 notforcodingquestion">
            {startQuestionLoader ? (
              <FullPageLoader isText={true} />
            ) : isSafari() ? (
              <StartSafariCamera
                ref={ref}
                SpeechRecognition={SpeechRecognition}
                timer={subTimer}
                currentQuestionIndex={currentQuestionIndex}
                questionId={questionData?.assessmentApplicantQuestionId}
                data={questionData}
                handleSubmitAnswer={handleSubmitAnswer}
                setStartQuestionLoader={setStartQuestionLoader}
                startQuestionLoader={startQuestionLoader}
                isStartRecording={isStartRecording}
                cameraStopped={cameraStopped}
              />
            ) : (
              <StartCamera
                ref={ref}
                SpeechRecognition={SpeechRecognition}
                timer={subTimer}
                currentQuestionIndex={currentQuestionIndex}
                questionId={questionData?.assessmentApplicantQuestionId}
                data={questionData}
                handleSubmitAnswer={handleSubmitAnswer}
                setStartQuestionLoader={setStartQuestionLoader}
                startQuestionLoader={startQuestionLoader}
                isStartRecording={isStartRecording}
                cameraStopped={cameraStopped}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default forwardRef(AnswerQuestion);
